import {TripCollection} from "./Trip";
import React from "react";
import {Box, Stack, useMediaQuery} from "@mui/material";
import TripListItem from "./TripListItem";
import chipColors from "./chipColors";
import StyledPageImage from "../StyledPageImage";

interface TripCollectionProps {
    tripCollection: TripCollection,
    index: number;
}

const TripCollectionComponent: React.FC<TripCollectionProps> = ({tripCollection, index}) => {
    const isMobile = useMediaQuery('(max-width:750px)');

    const direction = isMobile ? "column" :
        ((index % 2) ? "row" : "row-reverse")

    return (
        <Stack
            direction={direction}
            alignItems="stretch"
            sx={{
                borderRadius: 3,
                overflow: "hidden",
                boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
                transition: "box-shadow 0.3s ease",
                "&:hover": {boxShadow: "0 8px 32px rgba(0,0,0,0.28)"},
            }}
        >
            {/*image*/}
            <Box sx={{flex: isMobile ? "unset" : "0 0 60%", minHeight: isMobile ? 220 : "auto"}}>
                <StyledPageImage src={tripCollection.imageSrc} alt="excursie" isMobile={isMobile}/>
            </Box>

            {/*trip chips*/}
            <Box
                sx={{
                    flex: isMobile ? "unset" : "0 0 40%",
                    gap: "6px",
                    px: 2,
                    py: 1,
                    backgroundColor: (theme) => theme.palette.background.paper,
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {tripCollection.trips.map((trip) =>
                    <TripListItem trip={trip} color={chipColors[index % chipColors.length]}/>
                )}
            </Box>
        </Stack>
    )
}

export default TripCollectionComponent;